import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import { VideoJsSection } from '@/models/Videojs';

import SectionTitle from '../SectionTitle';

export default function VideoPoster(props: VideoJsSection) {
  const { sectionTitle, sectionDescription } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  return (
    <>
      {sectionTitle && (
        <h2>
          <SectionTitle
            text={sectionTitle}
            anchor='#section-highlights'
            stroke={desktop}
            align='center'
          />
        </h2>
      )}
      {sectionDescription && (
        <p
          className='pt-8 text-xl md:pt-0 md:text-[2rem]'
          data-aos='fade-in'
          data-aos-duration='600'
          data-aos-delay='300'
          data-aos-anchor='#section-highlights'
        >
          {sectionDescription}
        </p>
      )}
    </>
  );
}
